import { EnvelopeIcon } from '@heroicons/react/24/outline';
import cx from 'classnames';
import type { PropsWithChildren } from 'react';

type Props = PropsWithChildren<{
  color: string;
  className?: string;
  iconEnabled: boolean;
  style?: React.CSSProperties;
}>;

const EmailIconWrapper = ({ color, children, iconEnabled, className, style = {} }: Props) => {
  return (
    <div className={cx('flex w-full items-center', className)} style={style}>
      {iconEnabled && (
        <div
          className="pl-2"
          style={{
            color: color,
          }}
        >
          <EnvelopeIcon className="h-6 w-6" />
        </div>
      )}
      {children}
    </div>
  );
};

export default EmailIconWrapper;
